module.exports = __webpack_public_path__ + "static/media/venetian.b2346c09.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/venetian.ttf
// module id = 200
// module chunks = 0